import { render } from "./myImage.vue?vue&type=template&id=4de240cc&scoped=true"
import script from "./myImage.vue?vue&type=script&lang=js"
export * from "./myImage.vue?vue&type=script&lang=js"

import "./myImage.vue?vue&type=style&index=0&id=4de240cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de240cc"]])

export default __exports__